@if (collection.length == displayed.length) {
  <div>
    @switch (displayed.length) {
      @case (0) {
        <span [innerHTML]="'general.no.elements' | portalTranslate"></span>
      }
      @case (1) {
        <span [innerHTML]="'general.one.element' | portalTranslate"></span>
      }
      @default {
        <span [innerHTML]="'general.many.elements' | portalTranslate: { count: displayed.length }"> </span>
      }
    }
  </div>
}

@if (collection.length != displayed.length) {
  <div>
    @switch (displayed.length) {
      @case (0) {
        <span [innerHTML]="'general.no.filtered.elements' | portalTranslate: { total: collection.length }">
        </span>
      }
      @case (1) {
        <span [innerHTML]="'general.one.filtered.element' | portalTranslate: { total: collection.length }">
        </span>
      }
      @default {
        <span
          [innerHTML]="
            'general.many.filtered.elements'
              | portalTranslate: { count: displayed.length, total: collection.length }
          "
        >
        </span>
      }
    }
  </div>
}
